import {useMemo} from 'react'
import {type PlayerColor} from '@colonist/game-states'
import {type UIGamePlayerInfoSectionContentUsedDevsProps} from '../../UIGamePlayerInfo/index.ts'
import {useMechanicValidatorDevelopmentCard} from '../../../store/selectors/useMechanicValidatorDevelopmentCard.ts'
import {cardEnumsToCardState} from '../../../utils/cards.ts'

export const usePlayerInfoSectionContentUsedDevsProps = (playerColor: PlayerColor) => {
    const developmentCardsValidator = useMechanicValidatorDevelopmentCard()
    const usedDevelopmentCards = developmentCardsValidator?.getDevelopmentCardsPlayerState(playerColor).developmentCardsUsed
    if(usedDevelopmentCards == undefined) return null

    const cardStateUnordered = cardEnumsToCardState(usedDevelopmentCards)

    return useMemo<UIGamePlayerInfoSectionContentUsedDevsProps>(() => ({
        cardState: cardStateUnordered,
    }), [usedDevelopmentCards])
}
